<template>
  <div v-if="loadingDB" class="db-init">
    <div
      v-loading="true"
      element-loading-text="Loading..."
      class="db-init"
    ></div>
  </div>
  <div v-else class="db-init">
    <IndexLayout v-if="!simpleLayout">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </IndexLayout>
    <transition name="fade" mode="out-in" v-else>
        <router-view></router-view>
      </transition>
  </div>
</template>
<script type="text/babel">
import IndexLayout from "./layout/index";
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  components: {
    IndexLayout
  },
  data: ()=> ( {
    simpleLayout: false,
  }),
  computed: {
    ...mapState({
      yunModel: state => state.yunModel,
      loadingDB: state => state.loadingDB
    })
  },
  created: function() {
    let path = window.location.pathname
    this.simpleLayout = path.indexOf('/user/register') == 0 || path.indexOf('/user/login') == 0
  },
  watch: {
    '$route.path': function(newVal, oldVal) {
      this.simpleLayout = newVal.indexOf('/user/register') == 0 || newVal.indexOf('/user/login') == 0
    }
  },
  mounted() {}
};
</script>
<style scoped>
.db-init {
  width: 100%;
  height: 100%;
}
</style>
